<script>
    import Card from './Card.svelte';
import Grafico from '../grafico/Grafico.svelte';

    export let cardArrayValue = [{label: "prova 1", value: "22", percentage: "6", direction: 1}, {label: "prova 2", value: "32", percentage: "6", direction: 0},  {label: "prova 3", value: "32", percentage: "6", direction: -1}]
</script>

<div id="wrapper" class=" px-4 py-4 mx-auto mb-2">
    <div class="sm:grid sm:h-32 sm:grid-flow-row sm:gap-4 sm:grid-cols-4 ">
        {#each cardArrayValue as singleCard}
            <Card {...singleCard}></Card>
        {/each}
    </div>
</div>
